export const DATA_TEST_ID = 'category-selector-panel';
